import theme from '../theme/theme.module.scss';

const styles = getComputedStyle(window.document.body);

export const Theme = {
  primaryColor: styles.getPropertyValue('--primary-color'),
  inputBorderRadius: styles.getPropertyValue('--input-border-radius'),
  inputBorderHover: styles.getPropertyValue('--input-border-hover'),
  inputBorder: styles.getPropertyValue('--input-border'),

  inputTextColor: styles.getPropertyValue('--input-text-color'),
  inputPHColor: styles.getPropertyValue('--input-placeholder-color'),

  selectMenuBorder: styles.getPropertyValue('--select-menu-border'),
  selectMenuBorderRadius: styles.getPropertyValue('--select-menu-border-radius'),
};
